import React from 'react';
import FavoritesContainer from '../containers/favorites_container';

const FavoritesContext = React.createContext(new FavoritesContainer());

export default FavoritesContext;
